
import Dialog from '@mui/material/Dialog';
import { Stack, Box, Button, Typography } from '@mui/material';
import { MdError, MdInfo, MdOutlineWarning, MdCheckCircle} from "react-icons/md";
import { useTheme } from '@mui/material/styles';
import MainCard from 'components/MainCard';



/*
  PARAMS
    isOpen: false,
    setIsOpen: () => {},
    message: '',
    type: '', // 'success', 'error', 'warning', 'info'
    title: '', // optional
    customIcon: null, // optional custom icon component
    customIconColor: '', // optional custom icon color
    closeButtonTitle: 'Aceptar', // optional, default 'Aceptar'


  When using as context:
  import { useNotificationModal } from 'api/notification-modal';
  const openNotificationModal = useNotificationModal();
  openNotificationModal({
    message: 'Este es un mensaje de notificación',
    type: 'info',
    title: 'Título opcional',
    customIcon: SomeIcon,
    customIconColor: '#ff0000',
    closeButtonTitle: 'Cerrar'
  });
*/




function NotificacionModal(params) 
{
  const theme = useTheme();
  
  const onClose = () => {
    // Si hay onConfirm, ejecutarlo antes de cerrar
    if (params.onConfirm) {
      params.onConfirm();
    }
    
    params.setIsOpen(false);
  };

  const renderIcon = () => {
    if (params.customIcon) {
      const IconComponent = params.customIcon;
      return <IconComponent size={100} color={params.customIconColor || theme.palette.primary.main} />;
    }

    switch (params.type) {
      case 'success':
        return <MdCheckCircle size={100} color={theme.palette.success.main} />;
      case 'warning':
        return <MdOutlineWarning size={100} color={theme.palette.warning.main}/>;
      case 'error':
        return <MdError size={100} color={theme.palette.error.main} />;
      case 'info':
        return <MdInfo size={100} color={theme.palette.info.main} />;
      default:
        return null;
    }
  };


   if (!params.isOpen) return null;

   return (
    
    <Dialog onClose={onClose} open={params.isOpen}>
      <MainCard>
        <Stack 
          padding={2}
          alignItems='center'
          justifyContent='center'
          spacing={2}        
        >
          {renderIcon()}
          {params.title && (
            <Typography 
              variant="h3" 
              textAlign={'center'} 
              color={theme.palette.grey[800]}
            >
              {params.title}
            </Typography>
          )}
          <Box sx={{ wordWrap:'break-word', wordBreak:'break-word' }}>
            <Typography 
              sx={{fontSize:16, lineHeight:1.2 }}
              textAlign={'center'} 
              color={theme.palette.grey[600]} 
            >            
              {params.message}
            </Typography>
          </Box>
            
          {/* Botón para cerrar */}
          <Button onClick={onClose} variant='contained' size='large'>
            {params.closeButtonTitle || 'Aceptar'}
          </Button>
        </Stack>
      </MainCard>
    </Dialog>
  );
}

export default NotificacionModal;